// Challenge links: `<seed base36>.<homesLit>.<score>` under /c/. Decoding is
// strict — a link is untrusted input — and round-trips exactly.

const MAX_SEED = 0xffffffff;
const MAX_VALUE = 1e7;
const CODE_RE = /^([0-9a-z]{1,7})\.(0|[1-9]\d{0,7})\.(0|[1-9]\d{0,7})$/;
const PATH_RE = /^\/c\/([^/?#]+)\/?$/;

export function encodeChallenge({ seed, homesLit, score }) {
  const s = Number(seed) >>> 0;
  return `${s.toString(36)}.${Math.max(0, Math.floor(Number(homesLit) || 0))}.${Math.max(0, Math.floor(Number(score) || 0))}`;
}

export function decodeChallenge(code) {
  if (typeof code !== 'string') return null;
  const m = CODE_RE.exec(code);
  if (!m) return null;
  const seed = parseInt(m[1], 36);
  if (!Number.isFinite(seed) || seed < 0 || seed > MAX_SEED || seed.toString(36) !== m[1]) return null;
  const homesLit = Number(m[2]);
  const score = Number(m[3]);
  if (!Number.isInteger(homesLit) || !Number.isInteger(score)) return null;
  if (homesLit < 0 || score < 0 || homesLit > MAX_VALUE || score > MAX_VALUE) return null;
  return { seed, homesLit, score };
}

export function challengePath(challenge) {
  return `/c/${encodeChallenge(challenge)}`;
}

export function challengeFromPath(pathname) {
  if (typeof pathname !== 'string') return null;
  const m = PATH_RE.exec(pathname);
  if (!m) return null;
  let code = m[1];
  try {
    code = decodeURIComponent(code);
  } catch {
    return null;
  }
  return decodeChallenge(code);
}
